import React from 'react'
import { ButtonProps } from './Button.types'
import { PreffixWrapper, StyledButton } from './styled'

const Button: React.FC<ButtonProps> = ({
  children,
  icon,
  preffix,
  suffix,
  variant = 'primary',
  size = 'large',
  disabled = false,
  isBlock = false,
  ...restProps
}) => (
  <StyledButton
    variant={variant}
    size={size}
    disabled={disabled}
    icon={icon}
    suffix={suffix}
    isBlock={isBlock}
    {...restProps}
  >
    <PreffixWrapper>
      {preffix}
      {variant === 'circular' ? icon : icon || children}
    </PreffixWrapper>
    {suffix}
  </StyledButton>
)

export default Button
